var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"separateOrderText",attrs:{"data-auto":"separateOrderHeading"}},[_vm._v("\n  Другой пользователь разделил счет\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }